"use strict";

define('rs/models/setting',['require','exports','module','rs/models/abstract'],function (require, exports, module) {
  var RSAbstractModel = require('rs/models/abstract');
  var SettingModel = RSAbstractModel.extend({
    properties: ['activityDate', 'id', 'name', 'description', 'updateUserAuthId', 'value', 'version'],
    serverProperties: [],
    requestLoadByName: function requestLoadByName() {
      return this.constructor.requestLoadByName(this.getName());
    },
    requestLoadAll: function requestLoadAll() {
      return this.constructor.requestLoadAll();
    },
    requestBulkUpdate: function requestBulkUpdate(formValues) {
      return this.constructor.requestBulkUpdate(formValues);
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#GET#prop/list/:productId': function GETProp_list_ProductId(data) {
        var settingsObj = {},
          name = null;
        data = data || [];
        for (var i = 0, len = data.length; i < len; ++i) {
          name = this.getPropertyNameFromServerName(data[i].name);
          settingsObj[name] = this.parseSettingsObject(data[i]);
        }
        return settingsObj;
      },
      '#GET#prop/:prop': function GETProp_Prop(data) {
        return this.convertOnePropertyToValue(data);
      }
    },
    parseSettingsObject: function parseSettingsObject(setting) {
      var name = setting.name,
        paramIndex = name.indexOf(':');
      if (paramIndex == -1) {
        paramIndex = name.length;
      }
      return _.extend(setting, {
        namespace: name.slice(0, paramIndex),
        param: name.slice(paramIndex + 1, name.length),
        propName: name.slice(name.lastIndexOf('.') + 1, paramIndex),
        value: this.convertOnePropertyToValue(setting)
      });
    },
    getPropertyNameFromServerName: function getPropertyNameFromServerName(serverName) {
      if (!this._serverNames) {
        var serverNames = {};
        _.each(this.settings, function (v, k) {
          serverNames[v] = k;
        });
        this._serverNames = serverNames;
      }
      return this._serverNames[serverName] || serverName;
    },
    convertOnePropertyToValue: function convertOnePropertyToValue(prop) {
      var value = prop ? prop.value : null,
        strValue = String(value).toLowerCase();
      if (strValue == 'false') {
        return false;
      } else if (strValue == 'true') {
        return true;
      }
      return value;
    },
    requestLoadByName: function requestLoadByName(settingName) {
      return this.get('prop/' + settingName);
    },
    requestLoadAll: function requestLoadAll() {
      return this.get('prop/list/' + legacyApp.id);
    },
    requestOne: function requestOne(name) {
      var prop = this.settings[name];
      if (!prop) {
        return Promise.resolve(null);
      }
      return this.get('prop/' + prop);
    },
    requestBulkUpdate: function requestBulkUpdate(formValues) {
      var updateJson = {
        properties: formValues
      };
      return this.put('prop', updateJson, {
        jsonBody: true
      });
    },
    settings: {
      levelsOfOrgApprovers: 'IRB.LEVELS_OF_ORG_APPROVERS',
      fiscalYearFormat: 'EEE.FISCAL_YEAR_FORMAT',
      fiscalYearEnd: 'EEE.FISCAL_YEAR_END',
      timezone: 'EEE.TIMEZONE',
      studyDefaultExpirationInterval: 'IRB.DEFAULT_STUDY_EXPIRATION_INTERVAL',
      studySequenceNumber: 'IRB.STUDY_SEQUENCE_NUMBER',
      studyLabelPrefix: 'IRB.STUDY_LABEL_PREFIX',
      sequenceNumberStart: 'IRB.SEQUENCE_NUMBER_START',
      sequenceNumberReset: 'IRB.SEQUENCE_NUMBER_RESET',
      taskReminderInterval: 'IRB.TASK_REMINDER_INTERVAL',
      taskReminderMessageInterval: 'IRB.TASK_REMINDER_MESSAGE_INTERVAL',
      renewalReminderInterval: 'IRB.RENEWAL_REMINDER_INTERVAL',
      renewalReminderMessageInterval: 'IRB.RENEWAL_REMINDER_MESSAGE_INTERVAL',
      officeName: 'IRB.OFFICE_NAME',
      notificationFrom: 'IRB.NOTIFICATION_FROM',
      hasOrgApprovers: 'IRB.IRB_HAS_ORG_APPROVERS',
      orgApproverInitial: 'IRB.ORG_APPROVER_ITERATION:INITIAL',
      orgApproverRenewal: 'IRB.ORG_APPROVER_ITERATION:RENEWAL',
      orgApproverModification: 'IRB.ORG_APPROVER_ITERATION:MODIFICATION',
      orgApproverIncident: 'IRB.ORG_APPROVER_ITERATION:INCIDENT',
      orgApproverWithdrawal: 'IRB.ORG_APPROVER_ITERATION:WITHDRAWAL',
      orgApproverClosure: 'IRB.ORG_APPROVER_ITERATION:CLOSURE',
      certifyPersonnelInitial: 'IRB.CERTIFY_PERSONNEL:INITIAL',
      certifyPersonnelRenewal: 'IRB.CERTIFY_PERSONNEL:RENEWAL',
      certifyPersonnelModification: 'IRB.CERTIFY_PERSONNEL:MODIFICATION',
      certifyPersonnelIncident: 'IRB.CERTIFY_PERSONNEL:INCIDENT',
      certifyPersonnelWithdrawal: 'IRB.CERTIFY_PERSONNEL:WITHDRAWAL',
      certifyPersonnelClosure: 'IRB.CERTIFY_PERSONNEL:CLOSURE',
      recertifyPersonnelInitial: 'IRB.RECERTIFY_PERSONNEL:INITIAL',
      recertifyPersonnelRenewal: 'IRB.RECERTIFY_PERSONNEL:RENEWAL',
      recertifyPersonnelModification: 'IRB.RECERTIFY_PERSONNEL:MODIFICATION',
      recertifyPersonnelIncident: 'IRB.RECERTIFY_PERSONNEL:INCIDENT',
      recertifyPersonnelWithdrawal: 'IRB.RECERTIFY_PERSONNEL:WITHDRAWAL',
      recertifyPersonnelClosure: 'IRB.RECERTIFY_PERSONNEL:CLOSURE'
    }
  });
  module.exports = SettingModel;
});

